module.exports = __webpack_public_path__ + "static/media/manage_community_img.6029a6c6.png";